'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z' })
), 'DoNotDisturbOff');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/DoNotDisturbOff.js
// module id = 308
// module chunks = 0